import {
  ADD_QUERY_ENTITY_REQUEST,
  REMOVE_QUERY_ENTITY_REQUEST,
  UPDATE_QUERY_ENTITY_INFOS,
  CHANGE_QUERY_GROUP_OPERATOR_REQUEST,
  CLEAR_QUERY_REQUEST,
  MOVE_ENTITY_REQUEST,
  GET_TIMEFRAMES_REQUEST,
  CHANGE_AUDIENCE_TIMEFRAME_REQUEST,
  CHANGE_RESULT_TIMEFRAME_REQUEST,
  ADD_QUERY_ITEM_WITH_INFOS_REQUEST,
  CHANGE_BASE_QUERY_REQUEST,
  RESET_QUERY_ERROR,
  CHANGE_QUERY_TYPE_REQUEST,
  CHANGE_QUERY_BUILDER_TYPE_REQUEST,
  UPDATE_CONVERSATION_QUERY_REQUEST,
  DELETE_CONVERSATION_QUERY_REQUEST,
  ADD_CONVERSATION_ITEM_REQUEST,
  MOVE_CONVERSATION_ITEM_REQUEST,
  CLEAR_CONVERSATION_QUERY_REQUEST,
  RESET_CONVERSATION_QUERY_ERROR,
  INITIALIZE_QUERY_BUILDER,
  CHANGE_TARGET_COLOR,
  CHANGE_TARGET_TITLE,
  ADD_NEW_TARGET,
  REMOVE_TARGET,
  CHANGE_TARGET_SELECTED,
  CLEAR_ALL_QUERIES_REQUEST,
  COPY_TARGET,
  REPLACE_TARGET_QUERY_REQUEST,
  MERGE_TARGET_QUERY_REQUEST,
  SELECT_QUERY_GROUP_REQUEST,
  ADD_ITEM_WITH_INFOS_IN_SELECTED_GROUP_REQUEST,
  ADD_CONVERSATION_ITEM_IN_SELECTED_GROUP_REQUEST,
  CHANGE_QUERY_GROUP_AT_LEAST_NUMBER_REQUEST,
  ADD_BLOCK_IN_SELECTED_GROUP_REQUEST,
  CHANGE_DATA_SOURCE,
  CHANGE_DATA_SOURCE_REQUEST,
} from '../constants/action-types';

export const initializeQueryBuilder = targetId => ({
  type: INITIALIZE_QUERY_BUILDER,
  targetId,
});

export const addQueryEntityRequest = (
  targetId,
  entityType = 'item',
  groupId = 0,
  addOneMore = false
) => ({
  type: ADD_QUERY_ENTITY_REQUEST,
  targetId,
  groupId,
  entityType,
  addOneMore,
});

export const clearQueryRequest = targetId => ({
  type: CLEAR_QUERY_REQUEST,
  targetId,
});

export const updateQueryEntityInfos = (
  targetId,
  parentGroupId = 0,
  entityInfos,
  entityIndex
) => ({
  type: UPDATE_QUERY_ENTITY_INFOS,
  targetId,
  parentGroupId,
  entityInfos,
  entityIndex,
});

export const deleteEntityRequest = (targetId, parentGroupId, entityIndex) => ({
  type: REMOVE_QUERY_ENTITY_REQUEST,
  targetId,
  parentGroupId,
  entityIndex,
});

export const changeGroupOperatorRequest = (targetId, groupId, operator) => ({
  type: CHANGE_QUERY_GROUP_OPERATOR_REQUEST,
  targetId,
  groupId,
  operator,
});

export const changeGroupAtLeastNumberRequest = (
  targetId,
  groupId,
  atLeast
) => ({
  type: CHANGE_QUERY_GROUP_AT_LEAST_NUMBER_REQUEST,
  targetId,
  groupId,
  atLeast,
});

export const moveEntityRequest = (
  targetId,
  parentIdFrom,
  entityIndex,
  itemId,
  parentIdTo
) => ({
  type: MOVE_ENTITY_REQUEST,
  targetId,
  parentIdFrom,
  entityIndex,
  itemId,
  parentIdTo,
});

export const requestTimeframes = () => ({
  type: GET_TIMEFRAMES_REQUEST,
});

export const changeAudienceTimeframeRequest = (
  audience_timeframe,
  targetId
) => ({
  type: CHANGE_AUDIENCE_TIMEFRAME_REQUEST,
  audience_timeframe,
  targetId,
});

export const changeResultTimeframeRequest = (results_timeframe, targetId) => ({
  type: CHANGE_RESULT_TIMEFRAME_REQUEST,
  results_timeframe,
  targetId,
});

export const addQueryAnItemWithInfos = (targetId, groupId = 0, itemInfos) => ({
  type: ADD_QUERY_ITEM_WITH_INFOS_REQUEST,
  targetId,
  groupId,
  itemInfos,
});

export const addItemWithInfosInSelectedGroup = (targetId, itemInfos) => ({
  type: ADD_ITEM_WITH_INFOS_IN_SELECTED_GROUP_REQUEST,
  targetId,
  itemInfos,
});

export const addBlockInSelectedGroup = (targetId, block) => ({
  type: ADD_BLOCK_IN_SELECTED_GROUP_REQUEST,
  targetId,
  block,
});

export const changeBaseQueryRequest = (category, targetId) => ({
  type: CHANGE_BASE_QUERY_REQUEST,
  category,
  targetId,
});

export const resetQueryError = () => ({
  type: RESET_QUERY_ERROR,
});

export const changeQueryTypeRequest = (query_type, targetId) => ({
  type: CHANGE_QUERY_TYPE_REQUEST,
  query_type,
  targetId,
});

export const changeQueryBuilderTypeRequest = queryBuilderType => ({
  type: CHANGE_QUERY_BUILDER_TYPE_REQUEST,
  queryBuilderType,
});

export const addConversationItemRequest = (
  targetId,
  groupId = 0,
  itemInfos
) => ({
  type: ADD_CONVERSATION_ITEM_REQUEST,
  targetId,
  groupId,
  itemInfos,
});

export const addConversationItemInSelectedGroup = (targetId, itemInfos) => ({
  type: ADD_CONVERSATION_ITEM_IN_SELECTED_GROUP_REQUEST,
  targetId,
  itemInfos,
});

export const updateConversationQueryRequest = (
  targetId,
  parentGroupId = 0,
  entityContent,
  entityId,
  entityIndex
) => ({
  type: UPDATE_CONVERSATION_QUERY_REQUEST,
  targetId,
  parentGroupId,
  entityContent,
  entityId,
  entityIndex,
});

export const deleteConversationQueryRequest = (
  targetId,
  parentGroupId = 0,
  entityId,
  entityType
) => ({
  type: DELETE_CONVERSATION_QUERY_REQUEST,
  targetId,
  parentGroupId,
  entityId,
  entityType,
});

export const moveConversationItemRequest = (
  targetId,
  parentIdFrom,
  entityIndex,
  itemId,
  parentIdTo
) => ({
  type: MOVE_CONVERSATION_ITEM_REQUEST,
  targetId,
  parentIdFrom,
  entityIndex,
  itemId,
  parentIdTo,
});

export const clearConversationQueryRequest = () => ({
  type: CLEAR_CONVERSATION_QUERY_REQUEST,
});

export const resetConversationQueryError = () => ({
  type: RESET_CONVERSATION_QUERY_ERROR,
});

export const changeTargetColor = (targetId, color) => ({
  type: CHANGE_TARGET_COLOR,
  targetId,
  color,
});

export const changeTargetTitle = (targetId, title) => ({
  type: CHANGE_TARGET_TITLE,
  targetId,
  title,
});

export const addNewTarget = (options = {}) => ({
  type: ADD_NEW_TARGET,
  ...options,
});

export const removeTarget = targetId => ({
  type: REMOVE_TARGET,
  targetId,
});

export const changeTargetSelected = targetId => ({
  type: CHANGE_TARGET_SELECTED,
  targetId,
});

export const clearAllQueriesRequest = () => ({
  type: CLEAR_ALL_QUERIES_REQUEST,
});

export const copyTarget = (fromTarget, toTarget) => ({
  type: COPY_TARGET,
  fromTarget,
  toTarget,
});

export const replaceTargetQuery = (targetId, targetQuery) => ({
  type: REPLACE_TARGET_QUERY_REQUEST,
  targetId,
  targetQuery,
});

export const mergeTargetQuery = (targetId, sourceTargetQuery) => ({
  type: MERGE_TARGET_QUERY_REQUEST,
  targetId,
  sourceTargetQuery,
});

export const selectGroupRequest = (targetId, groupId) => ({
  type: SELECT_QUERY_GROUP_REQUEST,
  targetId,
  groupId,
});

export const changeDataSourceRequest = (dataSource, clearQuery) => ({
  type: CHANGE_DATA_SOURCE_REQUEST,
  dataSource,
  clearQuery,
});

export const changeDataSource = dataSource => ({
  type: CHANGE_DATA_SOURCE,
  dataSource,
});
